import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { VoiceProvider } from "./context/VoiceContext";
import Landing from "./pages/Landing";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from "./pages/Auth";
import VerifyEmail from "./pages/VerifyEmail";
import GoogleCallback from "./pages/GoogleCallback";
import Dashboard from "./pages/Dashboard";
import KanaPage from "./pages/Kana";
import Placement from "./pages/Placement";
import Tutor from "./pages/Tutor";
import { LessonsList, LessonDetail } from "./pages/Lessons";
import PricingPage from "./pages/Pricing";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Account from "./pages/Account";
import Review from "./pages/Review";
import JLPTMock from "./pages/JLPTMock";
import Fondateur from "./pages/Fondateur";
import Vocabulary from "./pages/Vocabulary";
import { BlogIndex, BlogArticle } from "./pages/Blog";
import AdminDashboard from "./pages/Admin";
import LessonThemePage from "./pages/LessonThemePage";
import CoursDeJaponais from "./pages/seo/CoursDeJaponais";
import ApprendreLeJaponais from "./pages/seo/ApprendreLeJaponais";
import ApprentissageDuJaponais from "./pages/seo/ApprentissageDuJaponais";
import RomajiKanaTool from "./pages/tools/RomajiKana";
import VoiceAudition from "./pages/VoiceAudition";
import AdminVoice from "./pages/AdminVoice";
import { InstallPWABanner } from "./components/InstallPWABanner";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="washi-bg min-h-screen" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const App = () => (
  <AuthProvider>
    <VoiceProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <InstallPWABanner />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/kana" element={<KanaPage />} />
          <Route path="/placement" element={<Placement />} />
          <Route path="/lessons" element={<LessonsList />} />
          <Route path="/lessons/theme/:slug" element={<LessonThemePage />} />
          <Route path="/lessons/:id" element={<LessonDetail />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/checkout/success" element={<PrivateRoute><CheckoutSuccess /></PrivateRoute>} />
          <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/tutor" element={<PrivateRoute><Tutor /></PrivateRoute>} />
          <Route path="/review" element={<PrivateRoute><Review /></PrivateRoute>} />
          <Route path="/jlpt" element={<JLPTMock />} />
          <Route path="/fondateur" element={<Fondateur />} />
          <Route path="/vocabulaire" element={<Vocabulary />} />
          <Route path="/outils/romaji-kana" element={<RomajiKanaTool />} />
          <Route path="/audition-voix" element={<VoiceAudition />} />
          <Route path="/admin/voix" element={<AdminVoice />} />
          <Route path="/cours-de-japonais" element={<CoursDeJaponais />} />
          <Route path="/apprendre-le-japonais" element={<ApprendreLeJaponais />} />
          <Route path="/apprentissage-du-japonais" element={<ApprentissageDuJaponais />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </VoiceProvider>
  </AuthProvider>
);

export default App;
